/**
 * Adds upload progress or app driven progress to form submission
 */
import formatBytes from "../../javascript/format-bytes.js";
import formatTime from "../../javascript/format-time.js";
import absUrl from "../../javascript/absolute-url.js";
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/dimensions/width-height/width-height.js";
import "dabbyjs/src/manipulation/html/html.js";
import "dabbyjs/src/ajax/ajax/ajax.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/manipulation/remove/remove.js";
import "dabbyjs/src/utils/each/each.js";

let win,
	cancel,
	hasCancelled = false,
	complete = false;

const writeProgress = (obj, title, percentage, text) => {
	if (!percentage) {
		percentage = 0;
	}

	// write html
	if (!win) {
		win = {
			title: $("<h3>", {"class": "progress__title"}),
			progress: $("<div>", {"class": "progress__percentage"}),
			text: $("<div>", {"class": "progress__text"})
		};
		obj.prepend(
			$("<div>", {"class": "progress"})
				.append($("<div>", {"class": "progress__inner"})
					.append($("<button>", {"class": "progress__cancel", text: "Cancel", click: e => {
						if (cancel && confirm("Are you sure you want to cancel?")) {
							cancel();
						}
						e.preventDefault();
					}}))
					.append(win.title)
					.append(win.progress)
					.append(win.text)
				)
		);
	}

	// update progress
	win.title.text(title + " ("+percentage.toFixed(0)+"%)");
	win.progress.width(percentage.toFixed(0) + "%");
	win.text.html(text);
},

getProgress = (obj, href) => {
	fetch(href + (hasCancelled ? "&cancel" : ""), {headers: {accept: "application/json"}})
		.then(response => {
			if (response.ok) {
				response.json().then(data => {
					if (data.msg && data.progress) {
						writeProgress(obj, data.msg, data.progress, data.detail);
					}

					if (!complete) {
						window.setTimeout(() => {
							getProgress(obj, href);
						}, 1000);
					}
				});
			}
		})
		.catch(err => {
			console.log(err);
		});
};

export default obj => {
	if (obj.length) {

		let button,
			selector = "input[type=submit],button[name]:not([type=button]):not([type=reset])";

		// track which submit button was pressed
		$(selector, obj).on("click", function () {
			button = $(this);
		});

		obj.on("submit", function (e) {
			complete = false;
			let $this = $(this),
				progress = button.data("progress") || $this.data("progress"),
				action = $this.attr("action") || "",
				data = new FormData(this),
				xhr,
				name,
				files = [];

			// indicate we want to redirect
			data.append("redirect", absUrl(action));

			// gather files
			$("input[type=file]", $this).each((i, item) => {
				$.each(item.files, (key, file) => {files.push(file);});
			});

			if (progress || files.length) {

				// append submit button onto data
				if (!button) {
					button = $(selector, $this);
				}
				name = button.attr("name");
				if (name) {
					data.append(name, button.val());
				}

				// post data
				xhr = $.ajax({
					url: action,
					method: "POST",
					data: data,
					contentType: null,
					xhr: () => {
						let xhr = new XMLHttpRequest(),
							lastloaded = 0,
							lasttime = new Date().getTime() / 1000,
							offset = 0,
							current = 0,
							rate = [];

						xhr.responseType = "blob";
						xhr.upload.addEventListener("progress", e => {

							// upload
							if (e.lengthComputable && files.length && e.loaded < e.total) {
								let time = new Date().getTime() / 1000,
									bps,
									remain,
									title,
									percentage = (e.loaded / e.total) * 100,
									text;

								// title
								title = "Uploading";

								// calculate upload percentage
								if (e.loaded > files[current].size + offset) { // track current file
									offset += files[current].size;
									if (current < files.length - 1) {
										current += 1;
									}
								}

								// smooth out rate
								if (rate.length > 25) {
									rate.shift();
								}
								rate.push((e.loaded - lastloaded) / (time - lasttime));
								bps = rate.reduce((a, b) => a + b, 0) / rate.length;

								// write text
								text = "Uploading \"" + files[current].name + "\"<br />";
								text += "Sent " + formatBytes(e.loaded, 2) + " of " + formatBytes(e.total, 2);
								text += " (" + formatBytes(bps, 2) + "ps)<br />";
								remain = formatTime((e.total - e.loaded) / bps);
								if (remain) {
									text += "Estimated time remaining: " + remain;
								}

								// write to screen and record last values
								writeProgress($this, title, percentage, text);
								lasttime = time;
								lastloaded = e.loaded;

							// server progress
							} else if (files.length || progress) {
								if (progress) {
									writeProgress($this, "Preparing . . .", 0, "");
									cancel = () => {
										hasCancelled = true;
									}
									getProgress($this, progress);
								} else {
									writeProgress($this, "Upload Complete", 100);
								}
							}
						});
						return xhr;
					},
					complete: xhr => {

						// remove progress window
						complete = true;
						$(".progress", $this).remove();
						win = null;

						// download file
						const disp = xhr.getResponseHeader("Content-Disposition"),
							type = xhr.getResponseHeader("Content-Type"),
							url = URL.createObjectURL(xhr.response);
						if (disp && disp.startsWith("attachment")) {
							const name = disp.split("filename=")[1] || null;
							if (name) {
								const a = document.createElement("a");
								a.href = url;
								a.download = name;
								document.body.appendChild(a);
								a.click();
							} else {
								location.assign(url);
							}

						// handle inline data
						} else {

							// convert blob to text
							xhr.response.text().then(response => {

								// check if instructional json, or just json to screen
								if (type && type.startsWith("application/json")) {
									const json = JSON.parse(response);
									location.assign(json.location || url);

								// dump response as HTML
								} else {
									const newDoc = document.open();
									newDoc.write(response);
									newDoc.close();
								}
							});
						}
					},
					abort: () => {
						complete = true;
						$(".progress", $this).remove();
						win = null;
					}
				});

				cancel = () => {
					complete = true;
					xhr.abort();
					$(".progress", $this).remove();
					win = null;
				};

				e.preventDefault();
			}
		});
	}
};
